import qs from 'qs';
export function serializeParams(params) {
    return qs.stringify(params, { arrayFormat: 'brackets' });
}
